"use client";
import Image from "next/image";

const detailsData = [
    { title: "Segment", info: "Startup", },
    { title: "Platform", info: "Web and Mobile application", },
    { title: "Geography", info: "Canada", },
    { title: "Timeline", info: "8 to 12 weeks", },
    { title: "Audience", info: "Climate professionals, teams, and partner organizations", },
    { title: "Primary outcomes", info: "Faster collaboration, higher engagement, clear visibility of initiatives and impact", },
    { title: "Services", info: "Strategy and ideation, digital product experiences, technology planning and delivery, growth systems", },
];

const PortfolioInfo = () => {
    return (
        <div
            id="desilo-portfolio-details-section"
            className="desilo-portfolio-details-section section-padding-top"
        >
            <div className="container custom-container">

                <div className="row g-4 justify-content-between">
                    <div className="quate-details-box">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none">
                                <g clipPath="url(#clip0_3257_80348)">
                                    <mask id="mask0_3257_80348" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="34">
                                        <path d="M42 33.5312L0 33.5312L0 0.53125L42 0.53125L42 33.5312Z" fill="white" />
                                    </mask>
                                    <g mask="url(#mask0_3257_80348)">
                                        <path d="M3.78651 3.40053C1.42857 6.03544 0.0138359 8.90987 0.0138359 13.7006C0.0138359 22.0844 5.9086 29.5101 14.1612 33.3426L16.2833 30.2287C8.50227 25.917 6.85173 20.4077 6.38019 16.8146C7.55913 17.5332 9.20961 17.7728 10.8602 17.5332C15.1044 17.0541 18.4055 13.7006 18.4055 9.14943C18.4055 6.99361 17.4623 4.83775 16.0475 3.161C14.397 1.48424 12.5107 0.765627 10.1528 0.765627C7.55913 0.765627 5.20119 1.96331 3.78651 3.40053ZM27.3654 3.40053C25.0076 6.03543 23.5928 8.90987 23.5928 13.7006C23.5928 22.0844 29.4875 29.5101 37.7402 33.3426L39.8623 30.2287C32.0812 25.917 30.4307 20.4076 29.9591 16.8146C31.1381 17.5332 32.7886 17.7728 34.4391 17.5332C38.6833 17.0541 41.9844 13.7006 41.9844 9.14943C41.9844 6.99361 41.0412 4.83775 39.6265 3.16099C38.2117 1.48424 36.0896 0.765624 33.7317 0.765625C31.1381 0.765625 28.7802 1.9633 27.3654 3.40053Z" fill="#E25926" />
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="clip0_3257_80348">
                                        <rect width="42" height="33" fill="white" transform="matrix(-1 0 0 1 42 0.53125)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div>
                            <div className="text">
                                “I am thrilled to be part of the founding team for Get2Net0, the world first climate action professional network. Our goal is to connect climate change professional to accelerate climate action”
                            </div>
                            <div>─ Le Luong</div>
                        </div>
                    </div>
                </div>

                {/* Project overview */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            Project <br />
                            overview
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <h3>A mobile and web platform where climate professionals collaborate, form communities, and accelerate solutions together.</h3>
                            <p className="portfolio-text">
                                Get2Net0 is a dedicated space for corporate and public sector climate action. The product brings people, projects, and knowledge into one place with communities, updates, collaborations, and messaging. We focused on reducing friction and increasing real world progress by pairing research driven design with reliable engineering across mobile and web.
                            </p>
                        </div>

                        {/* ✅ Dynamic Info Section with framer-motion */}
                        <div className="portfolio-details__info row-padding-top">
                            {detailsData.map((item, i) => (
                                <div key={i} className="portfolio-details-box">
                                    <span className="title">{item.title}</span>
                                    <h6 className="info">{item.info}</h6>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* ✅ Images Section */}
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/get2net0/2.png"
                            alt="Get2Net0 user profile page showing showcases, community memberships, activity feed, and profile completion checklist for sustainability engagement"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>

                {/* The Challenges */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            The <br />
                            Challenges
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <div className="portfolio-text">
                                <div className="border-bottom-text">
                                    <p>
                                        Unclear first steps for new creators
                                    </p>
                                    <p>
                                        Tooling felt overwhelming. Getting from first post to a simple offer was not obvious.
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Inconsistent engagement cadence
                                    </p>
                                    <p>
                                        Without a basic rhythm and prompts, posting stalled and momentum faded.
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Fragmented monetization
                                    </p>
                                    <p>
                                        Perks, paywalls, and subscriber messaging lived in different tools. Fans could not see the value easily.
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Hard to present a credible, single home
                                    </p>
                                    <p>
                                        Creators needed one place that explained what supporters get and why to join, with progress they could show.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* What we found */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            What <br />
                            we found
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                We designed a focused cross platform product that puts communities and collaborations at the center. Members can post updates, create or join topic communities, start collaboration threads, and message peers. On mobile, quick capture and notifications keep momentum high. On web, richer boards and admin tools make coordination simple. The experience highlights next steps and surfaces relevant people and projects so progress compounds.
                            </p>
                        </div>
                    </div>
                </div>

                {/* The Solution */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            The <br />
                            Solution
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                We designed a focused product that guides creators from setup to first earnings. The core includes a posting system, a clean subscriber hub, and a community space that keeps supporters engaged. The app highlights the next best action, bundles perks and messaging, and shows progress with simple dashboards both creators and fans understand.
                            </p>
                        </div>
                    </div>
                </div>

                {/* ✅ Images Section */}
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/get2net0/3.png"
                            alt="Get2Net0 platform development view showing code alongside Carbon Capture showcase card for climate innovation and sustainability solutions"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/get2net0/4.png"
                            alt="Get2Net0 showcase communities page displaying sustainability groups for collaboration, membership, and climate action initiatives"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/get2net0/5.png"
                            alt="Get2Net0 messages interface showing community member conversations and direct chats for collaboration and sustainability discussions"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>

                {/* Key Services */}
                <div>
                    <div className="row g-4 justify-content-between section-padding-top">
                        <div className="">
                            <h2 className="portfolio-details__title">
                                Key Services
                            </h2>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Strategy  & Ideation
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                We began with a fast product ideation sprint and stakeholder interviews to hear needs in plain language. From there, we mapped a simple offer for a professional home for climate action with communities, collaborations, and trusted profiles. We defined segments, sharpened the value proposition, and set a test plan where activation and collaboration creation were first order goals.
                            </p>
                            <div className="row justify-content-between pt-4">
                                <div className="col-md-4">
                                    <div className="desilo-project-box overflow-hidden">
                                        <div className="desilo-project-thumb overflow-hidden">
                                            <Image
                                                height={500}
                                                width={500}
                                                sizes="100vw"
                                                src="/images/portfolio-details/cabotto/blog-thumb.png"
                                                alt="Cabotto strategy and ideation process with UX wireframe sketches on a whiteboard for product design planning"
                                                className="w-100 h-100 img_reveal"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="desilo-project-box overflow-hidden">
                                        <div className="desilo-project-thumb overflow-hidden">
                                            <Image
                                                height={500}
                                                width={500}
                                                sizes="100vw"
                                                src="/images/portfolio-details/cabotto/blog-thumb-1.png"
                                                alt='Cabotto ideation session showing website creation flowchart with design, database, and CMS planning steps'
                                                className="w-100 h-100 img_reveal"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="desilo-project-box overflow-hidden">
                                        <div className="desilo-project-thumb overflow-hidden">
                                            <Image
                                                height={500}
                                                width={500}
                                                sizes="100vw"
                                                src="/images/portfolio-details/cabotto/blog-thumb-2.png"
                                                alt='Cabotto product team collaborating on coding and development, reviewing software interface and discussing technical solutions'
                                                className="w-100 h-100 img_reveal"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Digital product experiences
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                With direction set, we shaped the product from the ground up. We organized the sitemap, drew user flows, and explored wireframes before moving into visual design and a reusable design system. We prototyped community spaces, the collaboration flow, feeds, and messaging, then tested with real users to refine before build.                            </p>
                            <div className="row-padding-top overflow-hidden">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src="/images/portfolio-details/get2net0/6.png"
                                    alt="Get2Net0 digital product experience wireframe showing early platform design with placeholders for posts, communities, and collaborations"
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                            <div className="row-padding-top overflow-hidden">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src="/images/portfolio-details/get2net0/7.png"
                                    alt="Get2Net0 digital product experience final interface showing sustainability community posts, collaborations, and member engagement features"
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Technology & Transformation
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                We planned a SaaS ready architecture for both web and mobile. Core services expose clean APIs. Messaging, notifications, and media handling are integration ready. Analytics are first class. The delivery pipeline supports frequent, calm releases across platforms with observability to keep operations quiet at scale.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Outcomes */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            Outcomes
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                Get2Net0 launched as a credible, professional home for climate collaboration on mobile and web. Members can find peers, form communities, start collaborations, and show progress, while leadership finally sees activity and momentum in one place.
                            </p>
                            <div className="row-padding-top border-bottom-text border-0 pb-0">
                                <p>Highlights</p>
                                <ul>
                                    <li><span>Built a custom livestream module in 2 weeks and integrated with OBS for production ready streams.</span></li>
                                    <li><span>Shipped the core monetization flow in 1 week, including perks, tiers, and a clean paywall.</span></li>
                                    <li><span>Implemented Persona for user verification, Stripe for payments and payouts, and AWS for hosting and storage.</span></li>
                                    <li><span>User feedback: easy to start, creators love the experience, and anyone with a niche can become a creator and earn.</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortfolioInfo;
